import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';

/**
 * Generated class for the LoadzonesroutingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-loadzonesrouting',
  templateUrl: 'loadzonesrouting.html',
})
export class LoadzonesroutingPage {

  Data = []
  _selectedZoneId = 0
  _title = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad LoadzonesroutingPage');
    this.loadData()
  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }

  loadData() {
    this._title = this.dic.l["downloadFromZone"]

    var _that = this
    this.gn._Post('/api/gn/getzonesrouting', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {

      // _that.Data = _data
      for (var i = 0; i < _data.length; i++) {
        //if (_data[i].cntpois < 25) {
        if (_data[i].groupid + '' == '1') _data[i].groupname = _that.dic.l["Ungrouped"];
        _data[i].visible = true
        _that.Data.push(_data[i])
        //}

      }
    })
  }

  loadzonesrouting() {
    var cb = this.navParams.get('cb')
    cb(this._selectedZoneId)
    this.navCtrl.pop()
  }


  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }    
    const val = ev.target.value.toLowerCase()
    for (var i = 0; i < this.Data.length; i++) {
      if (val == '') {
        this.Data[i].visible = true
      } else {
        var itm = this.Data[i].name.toLowerCase()
        if (itm.indexOf(val) > -1) {
          this.Data[i].visible = true
        } else {
          this.Data[i].visible = false
        }
      }

    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/loadzonesrouting/loadzonesrouting.ts